import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { DialogActionsComponent } from '@ui/Components/Dialog/DialogActions.Component'
import { NgStyle } from '@angular/common'
import { ButtonComponent } from '@ui/Components/Form/Button/Button.Component'

@Component({
	selector: 'confirm-account-details-dialog',
	templateUrl: './ConfirmAccountDetailsDialog.Component.html',
	imports: [DialogComponent, DialogActionsComponent, NgStyle, ButtonComponent],
})
export class ConfirmAccountDetailsDialogComponent {
	public readonly systemConfig: SystemConfigService

	private readonly dialogRef: MatDialogRef<ConfirmAccountDetailsDialogComponent>

	constructor() {
		this.systemConfig = inject(SystemConfigService)
		this.dialogRef = inject(MatDialogRef<ConfirmAccountDetailsDialogComponent>)
	}

	public closeDialog = () => {
		this.dialogRef.close(false)
	}

	public confirmDetails = () => {
		this.dialogRef.close(true)
	}
}
